<app-dialog-header [title]="'general.api_reservation_make_description'" [withConfirm]="true" (closed)="confirmClose()"></app-dialog-header>
<div class="dialog-info">
  <div class="label-value bottom-spacer">
    <span class="label">{{'general.api_reservation_events' | translate}}:</span>
    <ng-container *ngFor="let title of titles; let firstTitle = first">
      {{ title | translateValue }}<ng-container *ngIf="!firstTitle">,&nbsp;</ng-container>
    </ng-container>
  </div>
  <div class="flex">
    <div class="label-value">
      <span class="label">{{'general.api_reservation_tickets' | translate}}:</span>
      {{cartService.ticketQuantity}}
    </div>
    <div class="label-value">
      <span class="label">{{'general.api_reservation_list_amount' | translate}}:</span>
      {{cartService.totalSum | price}}
    </div>
  </div>
</div>
<mat-dialog-content>
  <app-loader [loading]="isLoading" [overlay]="true"></app-loader>
  <div class="flex flex-column">
    <app-label-value [label]="'general.api_reservation_type'" [template]="bookingTypeTemplate" [withMargin]="true"></app-label-value>
    <ng-template #bookingTypeTemplate>
      <mat-radio-group class="flex flex-column-mobile" [(ngModel)]="bookingFormType" (change)="clearHiddenFields()">
        <mat-radio-button [value]="BookingFormType.Private">{{'general.api_reservation_type_private' | translate}}</mat-radio-button>
        <mat-radio-button [value]="BookingFormType.Legal">{{'general.api_reservation_type_legal' | translate}}</mat-radio-button>
        <mat-radio-button *ngIf="isPromoter && isSameOrganiser" [value]="BookingFormType.Promoter">{{'general.api_reservation_type_organiser' | translate}}</mat-radio-button>
      </mat-radio-group>
    </ng-template>
    <app-label-value class="mobile" [label]="'general.api_reservation_info'" [noValue]="true"></app-label-value>
    <div class="flex flex-grow flex-column-mobile">
      <div class="flex flex-column" *ngIf="bookingFormType !== BookingFormType.Promoter">
        <div class="flex flex-flat" *ngIf="bookingFormType === BookingFormType.Legal">
          <app-scroll-load label="general.api_reservation_form_legal_person"
                           [minInput]="3"
                           [customQuery]="legalPersonService.setPageableQueryCompanyName"
                           [searchService]="legalPersonService" [scrollLoad]="legalPersonScrollLoad"
                           [withSuffix]="true" [disabled]="showLegalPersonForm"
                           [required]="true"
                           [(selectedObjectId)]="bookingPost.legalPersonId" (selectedObjectIdChange)="selectLegalPersonById($event)"></app-scroll-load>
          <button mat-button class="icon-button input-button suffix-button" (click)="displayLegalPersonForm()">
            <mat-icon class="svg-icon" [svgIcon]="'add_legal_person'"></mat-icon>
          </button>
        </div>
        <div class="flex flex-flat">
          <app-scroll-load label="general.api_reservation_table_customer"
                           [minInput]="bookingPost.legalPersonId ? 0 : 2"
                           [customFilters]="{legalPersonId: bookingPost.legalPersonId}"
                           [searchService]="customerService" [scrollLoad]="customerScrollLoad"
                           [withSuffix]="true" [disabled]="showCustomerForm"
                           [required]="true"
                           [(selectedObjectId)]="bookingPost.customerUuid" (selectedObjectIdChange)="selectCustomerById($event)"></app-scroll-load>
          <button mat-button class="icon-button input-button suffix-button" (click)="displayCustomerForm()">
            <mat-icon class="svg-icon" [svgIcon]="'add_user'"></mat-icon>
          </button>
        </div>
      </div>
      <app-datepicker [dateStart]="bookingDate" [(dateEnd)]="dueDate" [datePickerConfig]="bookingDateConfig"></app-datepicker>
    </div>
  </div>
  <div class="dialog-inner-component" *ngIf="showLegalPersonForm">
    <app-legal-person-view [withoutFooter]="true" (cancelChange)="this.showLegalPersonForm = false" (confirmChange)="selectLegalPerson($event)"
                           [isInternalComponent]="true"></app-legal-person-view>
  </div>
  <div class="dialog-inner-component" *ngIf="showCustomerForm">
    <app-customer-view [withoutFooter]="true" (cancelChange)="this.showCustomerForm = false" (confirmChange)="selectCustomer($event)"
                       [legalPerson]="customerLegalPerson" [isInternalComponent]="true"></app-customer-view>
  </div>
  <hr>
  <div class="flex flex-column">
    <div class="flex flex-grow flex-column-mobile" *ngIf="bookingPost.type !== bookingType.Organiser">
      <mat-form-field appearance="outline" class="no-hint">
        <mat-label>{{ 'general.api_reservation_list_payment_type' | translate }}</mat-label>
        <mat-select [(ngModel)]="bookingPost.paymentType" [ngModelOptions]="{standalone: true}">
          <mat-select-trigger>{{ ('general.api_cart_' + bookingPost.paymentType) | translate }}</mat-select-trigger>
          <mat-option [value]="null">-</mat-option>
          <mat-option *ngFor="let paymentType of bookingOptions.paymentType" [value]="paymentType">
            {{ ('general.api_cart_' + paymentType) | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" class="no-hint" *ngIf="bookingPost.type !== bookingType.Organiser">
        <mat-label>{{ 'general.api_reservation_list_delivery_type' | translate }}</mat-label>
        <mat-select [(ngModel)]="bookingPost.deliveryTypeId" [ngModelOptions]="{standalone: true}">
          <mat-select-trigger>{{ displayDeliveryTypeName | translate }}</mat-select-trigger>
          <mat-option [value]="null" *ngIf="bookingFormType === BookingFormType.Promoter">-</mat-option>
          <mat-option *ngFor="let deliveryType of bookingOptions.deliveryType" [value]="deliveryType.id">
            {{deliveryType.name | translate}}&nbsp;-&nbsp;{{deliveryType.price | price}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="flex flex-grow flex-column-mobile">
      <app-text-input class="max-width" [type]="TextInputType.Textarea"
                      [label]="'general.api_reservation_list_notes'" [(value)]="bookingPost.notes" [max]="1000"></app-text-input>
      <app-text-input class="max-width" *ngIf="bookingPost.type !== bookingType.Organiser" [type]="TextInputType.Textarea"
                      [label]="'general.api_reservation_internal_comment'" [(value)]="bookingPost.internalComment"></app-text-input>
    </div>
  </div>
</mat-dialog-content>
<app-dialog-footer [dialogActions]="actionButtons"></app-dialog-footer>
<ng-template #actionButtons>
  <button mat-button (click)="confirmClose()">{{ 'general.api_general_close' | translate }}</button>
  <button mat-flat-button color="primary" [disabled]="!isValid" (click)="create()">{{ 'general.api_reservation_make' | translate }}</button>
</ng-template>
